// Shared JSON-LD schema builders for Corrective Motion.
const SITE_URL = "https://correctivemotion.com";
const LOGO = `${SITE_URL}/cm/cm-logo.png`;
const PHONE = "+971555657853";
const EMAIL = "hello@correctivemotion.com";

export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Corrective Motion",
  url: SITE_URL,
  logo: LOGO,
  sameAs: ["https://instagram.com/correctivemotion_"],
  founder: { "@type": "Person", name: "Anoop Gopi" },
  areaServed: { "@type": "City", name: "Dubai" },
};

export const personSchema = {
  "@context": "https://schema.org",
  "@type": "Person",
  name: "Anoop Gopi",
  jobTitle: "Elite Corrective Exercise Specialist & Personal Trainer",
  worksFor: { "@type": "Organization", name: "Corrective Motion" },
  image: `${SITE_URL}/cm/anoop-gopi-corrective-exercise-specialist-dubai.webp`,
  url: SITE_URL,
  telephone: PHONE,
  email: EMAIL,
  address: {
    "@type": "PostalAddress",
    addressLocality: "Dubai",
    addressCountry: "AE",
  },
  hasCredential: [
    "NASM - National Academy of Sports Medicine",
    "ACSM - American College of Sports Medicine",
    "NSCA CSCS - Certified Strength and Conditioning Specialist",
    "UAE REPs Registered Professional",
    "ACE - American Council on Exercise",
  ],
  knowsAbout: [
    "Corrective Exercise",
    "Posture Correction",
    "Pain Management Through Exercise",
    "Mobility & Flexibility Coaching",
    "Strength & Conditioning",
    "Functional Training",
    "Fat Loss",
    "Muscle Building",
    "Sports Performance",
    "Rehabilitation",
  ],
};

export const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": ["ProfessionalService", "HealthAndBeautyBusiness"],
  "@id": `${SITE_URL}/#business`,
  name: "Corrective Motion",
  image: `${SITE_URL}/og-image.jpg`,
  logo: LOGO,
  url: SITE_URL,
  telephone: PHONE,
  email: EMAIL,
  priceRange: "AED",
  address: {
    "@type": "PostalAddress",
    streetAddress: "Train Strength & Fitness, Dubai Mall · Zabeel Expansion",
    addressLocality: "Downtown Dubai",
    addressRegion: "Dubai",
    postalCode: "00000",
    addressCountry: "AE",
  },
  geo: {
    "@type": "GeoCoordinates",
    latitude: 25.1972,
    longitude: 55.2793,
  },
  hasMap: "https://www.google.com/maps/search/?api=1&query=Train+Strength+%26+Fitness+Dubai+Mall+Zabeel",
  areaServed: [
    { "@type": "City", name: "Dubai" },
    { "@type": "Place", name: "Downtown Dubai" },
    { "@type": "Place", name: "DIFC" },
    { "@type": "Place", name: "Business Bay" },
    { "@type": "Place", name: "Dubai Marina" },
    { "@type": "Place", name: "Palm Jumeirah" },
    { "@type": "Place", name: "Jumeirah" },
  ],
  openingHoursSpecification: [
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
      opens: "06:00",
      closes: "22:00",
    },
  ],
  sameAs: ["https://instagram.com/correctivemotion_"],
  founder: { "@type": "Person", name: "Anoop Gopi" },
  makesOffer: [
    "Personal Training Dubai",
    "Corrective Exercise Dubai",
    "Posture Correction Dubai",
    "Back Pain Personal Trainer Dubai",
    "Weight Loss Personal Training Dubai",
    "Muscle Building Coach Dubai",
    "Functional Training Dubai",
    "Strength and Conditioning Coaching Dubai",
    "Post Rehabilitation Exercise Dubai",
    "Injury Prevention Training Dubai",
    "Mobility Training Dubai",
    "Home Personal Training Dubai",
    "Online Personal Training Dubai",
    "Corporate Personal Training Dubai",
    "Small Group Personal Training Dubai",
  ].map((n) => ({ "@type": "Offer", itemOffered: { "@type": "Service", name: n } })),
};

export const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "Corrective Motion",
  url: SITE_URL,
  potentialAction: {
    "@type": "SearchAction",
    target: `${SITE_URL}/blog?q={search_term_string}`,
    "query-input": "required name=search_term_string",
  },
};

export const breadcrumbSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: it.name,
    item: `${SITE_URL}${it.path}`,
  })),
});

export const serviceSchema = ({ name, description, path, areaServed = "Dubai" }) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  serviceType: name,
  name,
  description,
  provider: { "@type": "Organization", name: "Corrective Motion", url: SITE_URL },
  areaServed: { "@type": "City", name: areaServed },
  url: `${SITE_URL}${path}`,
});

export const faqSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: items.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
});

export const articleSchema = ({ title, description, path, datePublished, image }) => ({
  "@context": "https://schema.org",
  "@type": "Article",
  headline: title,
  description,
  image: image || `${SITE_URL}/og-image.jpg`,
  mainEntityOfPage: `${SITE_URL}${path}`,
  author: { "@type": "Person", name: "Anoop Gopi" },
  publisher: {
    "@type": "Organization",
    name: "Corrective Motion",
    logo: { "@type": "ImageObject", url: LOGO },
  },
  datePublished: datePublished || "2026-05-01",
  dateModified: "2026-06-01",
});

export const constants = { SITE_URL, PHONE, EMAIL, LOGO };
